import React from 'react';

import { color } from '@morressier/ts';

import styled from 'styled-components';

import { SubTitle } from 'containers/styles';

import * as Styles from './styles';

const Section = styled.section`
  padding: 0 2rem;
  margin-bottom: 4rem;
  color: ${color('secondaryBrand')};
`;

type Props = {
  title: string;
  children: React.ReactNode;
  showTitle?: boolean;
  id?: string;
  style?: React.CSSProperties;
};

const ArticleSection = React.forwardRef<HTMLElement, Props>(
  ({ showTitle = true, title, children, style }, ref) => (
    <Section ref={ref} style={style}>
      <Styles.SectionContainer>
        {showTitle && <SubTitle>{title}</SubTitle>}
        <div>{children}</div>
      </Styles.SectionContainer>
    </Section>
  ),
);

export default ArticleSection;
